import React, { useContext, useEffect, useState } from 'react';
import { styled } from '@this/constants/themes';
import { Button as MuiButton } from '@material-ui/core';
import AppointContext from '@this/components/appoint/appoint_context';

type Props = {
  googleOauthPath: string;
  outlookOauthPath: string;
};
export const SigninButtons = ({ googleOauthPath, outlookOauthPath }: Props) => {
  const [csrfToken, setCsrfToken] = useState<string | null>(null);

  // csfrtokenをmetaから取得してformdataとしてrailsのomniauthに送る
  useEffect(() => {
    const rawCsrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (!rawCsrfToken) {
      throw new Error('Not found meta[name="csrf-token"]');
    }
    setCsrfToken(rawCsrfToken);
  }, []);

  return csrfToken ? (
    <>
      <SignInButton
        signinUrl={googleOauthPath}
        csrfToken={csrfToken}
        renderButtonImg={<img src="/images/sign_in_with_google.png" width="191" />}
      />
      {/** microsoftログインの場合、直接認証画面に遷移するためcsfrいらない */}
      <SignInButton
        signinUrl={outlookOauthPath}
        renderButtonImg={<img src="/images/sign_in_with_microsoft.png" width="215" />}
      />
    </>
  ) : null;
};

type ButtonProps = {
  signinUrl: string;
  csrfToken?: string;
  renderButtonImg: React.ReactNode;
};

/**
 * formを使用してPOSTリクエストを行う。(fetch APIなどでPOSTするとGoogleへのリダイレクト時にCORSエラーになるため)
 */
const SignInButton = ({ signinUrl, csrfToken, renderButtonImg }: ButtonProps) => {
  const contextValue = useContext(AppointContext);

  return csrfToken ? (
    <form action={signinUrl} method="post">
      <input type="hidden" value={csrfToken} name="authenticity_token" />
      <Button type="submit" isMobile={contextValue.isMobile}>
        {renderButtonImg}
      </Button>
    </form>
  ) : (
    <a href={signinUrl}>{renderButtonImg}</a>
  );
};

const Button = styled(MuiButton)<{ isMobile: boolean }>`
  display: block;
  margin: 10px 0 0 -10px;

  ${props =>
    props.isMobile &&
    `
    margin: 0 auto;
  `}
`;
